import React from "react";

function CustomBackground(props) {
	return <div style={{height: "500px", width: "500px", background: "blue"}} />;
}

export default CustomBackground;
